import React from "react"
import { useFeaturedWork } from "../../hooks/use-featured-work"
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectCoverflow, Scrollbar, Keyboard } from "swiper/modules"

// import Swiper and modules styles
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/scrollbar"

import "./FeaturedWork.module.css"

export default function FeaturedWork() {
  const workList = useFeaturedWork()

  return (
    <Swiper
      //effect={'coverflow'}
      grabCursor={true}
      scrollbar={true}
      keyboard={{
        enabled: true,
      }}
      spaceBetween={30}
      slidesPerView={1.5}
      coverflowEffect={{
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      }}
      breakpoints={{
        640: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 50,
        },
      }}
      modules={[EffectCoverflow, Scrollbar, Keyboard]}
    >
      {workList.map((item) => {
        const imageSrc = item.node.workFields?.tileImage

        return (
          <SwiperSlide className="my-3" key={item.node.id}>
            <a href={`/work/${item.node.slug}`} className="block group">
              <div className={`aspect - [9 / 10] flex-none overflow-hidden `}>
                {imageSrc && (
                  <img
                    src={imageSrc}
                    alt={item.node.title}
                    className="w-full h-full object-cover border-[4px] border-black shadow-[5px_5px_0px_0px_rgba(0,0,0,1)] group-hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] group-hover:translate-x-[-3px] group-hover:translate-y-[-3px] transition-all duration-150"
                  />
                )}
                {/*<div className="absolute bottom-0 left-0 right-0 bg-lime-400 border-t-[4px] border-black p-2"> */}
                <h3 className="text-slate-300 group-hover:text-white transition-all duration-250 font-bold mt-4 border-0">
                  {item.node.title}
                </h3>
                {/*</div> */}
              </div>
            </a>
          </SwiperSlide>
        )
      })}
    </Swiper>
  )
}
